if (!customElements.get('hs-share')) {
  customElements.define('hs-share', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const dialog = this.querySelector('dialog');
      const textarea = this.querySelector('textarea');
      const status = this.querySelector('[role="status"]');
      const full = `${this.dataset.message}\n\n${this.dataset.url}`;
      textarea.value = full;
      const primary = this.querySelector('.hs-share__primary');
      const mobile = window.matchMedia('(max-width: 749px)');
      const updateLink = () => {
        primary.href = (mobile.matches ? 'whatsapp://send?text=' : 'https://web.whatsapp.com/send?text=') + encodeURIComponent(full);
        if (mobile.matches) {
          primary.removeAttribute('target');
          primary.removeAttribute('rel');
        } else {
          primary.target = '_blank';
          primary.rel = 'noopener noreferrer';
        }
      };
      updateLink();
      mobile.addEventListener('change', updateLink);
      this.querySelector('[data-share-more]').addEventListener('click', async () => {
        if (typeof navigator.share === 'function') {
          try {
            await navigator.share({ title: this.dataset.title, text: this.dataset.message, url: this.dataset.url });
            return;
          } catch (error) {
            if (error.name === 'AbortError') return;
          }
        }
        status.textContent = '';
        dialog.showModal();
      });
      this.querySelector('[data-share-close]').addEventListener('click', () => dialog.close());
      this.querySelector('[data-share-copy]').addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(full);
          status.textContent = this.dataset.copied;
        } catch {
          textarea.focus();
          textarea.select();
          status.textContent = this.dataset.manual;
        }
      });
    }
  });
}
